import Vue from "vue";
import LocationSelect from "./LocationSelect.vue";

export const locationSelect = (configs) =>
  configs.map(
    ({ el, ...props }) =>
      new Vue({
        el,
        name: "LocationSelectWrapper",
        render(h) {
          return h(LocationSelect, {
            props,
          });
        },
      })
  );
